// extracted by mini-css-extract-plugin
export var locationCard = "_gv-0";